import { doc, writeBatch } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { FaqGroupDataToUpdate } from "../types";

export const bulkUpdateFaqGroups = async (
  data: FaqGroupDataToUpdate[],
): Promise<void> => {
  const batch = writeBatch(db);

  data.forEach((faqGroup) => {
    const docRef = doc(db, `/faqGroups/${faqGroup.id}`);
    batch.update(docRef, faqGroup);
  });

  await batch.commit();
};
